<template>
  <div v-bind="$attrs">
    <label>
      {{ label }}
      <v-file-input
        :model-value="allowMultiple ? value : value?.[0]"
        data-testid="so-file-input"
        :label="placeholder"
        counter
        show-size
        :multiple="allowMultiple"
        :rules="rules"
        :accept="fileTypes"
        :prepend-icon="icon"
        variant="solo"
        @update:model-value="updateValue"
      >
      </v-file-input>
    </label>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { ValidationRule } from "@/types/ValidationRule"

  export default defineComponent({
    inheritAttrs: false,

    props: {
      modelValue: {
        type: Array<File>,
        default: () => [],
      },
      label: {
        type: String,
        default: "",
      },
      placeholder: {
        type: String,
        default: "",
      },
      rules: {
        type: Array as PropType<ValidationRule[]>,
        default: [] as ValidationRule[],
      },
      allowMultiple: {
        type: Boolean,
        default: false,
      },
      fileTypes: {
        type: String,
        default: "image/png, image/jpeg, image/heic, image/heif",
      },
      icon: {
        type: String,
        default: "",
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value() {
        return this.modelValue
      },
    },
    methods: {
      updateValue(val: File | File[]) {
        if (this.allowMultiple) {
          this.$emit("update:modelValue", Array.isArray(val) ? val : [val])
        } else {
          this.$emit("update:modelValue", val ? [val] : [])
        }
      },
    },
  })
</script>
<style scoped>
  :deep(.v-field:hover) {
    border: 1px solid rgb(var(--v-theme-on-surface));
  }
  :deep(.v-field--focused) {
    outline: var(--theme-outline);
  }
  :deep(.v-field--error) {
    border: 1px solid rgb(var(--v-theme-error)) !important;
  }
  :deep(.v-field--variant-solo) {
    box-shadow: none !important;
    border: 1px solid rgb(var(--v-theme-border));
  }
</style>
